export const APP_NAME = "Groundwork Command";
export const APP_SHORT_NAME = "GWC";
export const APP_TAGLINE = "Command the field.";

export const LOGO_SRC = "/brand/groundwork-command-wordmark.png";
// 2304×2304 PNG with transparent background — owner-selected from
// "done5 Background Removed.png" (the clean hex+G+watermark backdrop
// from the May-5 screenshot). Originally 8.6 MB at 3023×3456; resized
// to 2304 (still 2× the largest consumer at 1152px) and palette-
// quantized via sharp at quality 80 → 1.5 MB. Excluded from the PWA
// precache via vite-plugin-pwa globIgnores so first-paint is
// unaffected; loads when the blueprint backdrop renders.
export const LOGO_ICON_SRC = "/brand/groundwork-command-icon.png";

/** Gold accent from the Groundwork Command brand mark. */
export const BRAND_ACCENT = "hsl(38 67% 47%)";
export const BRAND_ACCENT_HSL = "38 67% 47%";
